import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from "chart.js"

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend)

// Palette categoriale validata (slot 1 blu / slot 2 arancio)
const COLOR_CREATED  = "#2a78d6"
const COLOR_MODIFIED = "#eb6834"
const COLOR_GRID     = "#e1e0d9"
const COLOR_AXIS     = "#898781"
const COLOR_TEXT     = "#52514e"

export default class extends Controller {
  static values = {
    labels: Array,
    created: Array,
    modified: Array,
    createdLabel: String,
    modifiedLabel: String
  }

  connect() {
    this.chart = new Chart(this.element, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [
          this.dataset_(this.createdLabelValue, this.createdValue, COLOR_CREATED),
          this.dataset_(this.modifiedLabelValue, this.modifiedValue, COLOR_MODIFIED)
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: COLOR_AXIS }
          },
          y: {
            beginAtZero: true,
            ticks: { color: COLOR_AXIS, precision: 0 },
            grid: { color: COLOR_GRID }
          }
        },
        plugins: {
          legend: {
            position: "top",
            align: "start",
            labels: { color: COLOR_TEXT, boxWidth: 12, boxHeight: 12 }
          },
          tooltip: {
            backgroundColor: "#fcfcfb",
            titleColor: "#0b0b0b",
            bodyColor: "#52514e",
            borderColor: "#c3c2b7",
            borderWidth: 1,
            padding: 10,
            cornerRadius: 6
          }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }

  dataset_(label, data, color) {
    return {
      label,
      data,
      backgroundColor: color,
      borderRadius: { topLeft: 4, topRight: 4, bottomLeft: 0, bottomRight: 0 },
      borderSkipped: false,
      maxBarThickness: 22,
      categoryPercentage: 0.7,
      barPercentage: 0.85
    }
  }
}
